<template>
    <div class="welcome container">
      <div class="card ">
        <div class="card-content center-align">
          <h2 class="teal-text">Welcome <br>
          <p>Chat on a Global Chat </p> </h2>
          <form @submit.prevent="enterChat">
            <label for="name">Enter Your Name</label>
            <input type="text" name="name" class="input-name" v-model="name">
            <p v-if="feedback" class="red-text">{{feedback}}</p>
            <button class="btn teal">Enter Chat</button>
          </form>
        </div>
      </div>
      <p>By entering into chat room you are agreeing the <b @click="showTerms">terms</b> of use this webapp.</p>
      <p v-if="terms">This webapp is made for training purposes for the developer, any misuse or entering inappropriate messages with bad/vulgar language or explicit mention of anyone is the sole responsibilty of the user.</p>
    </div>
</template>

<script>
export default {
    name:'Welcome',
    data(){
      return{
        name:null,
        feedback:null,
        terms:false
      }

    },
    methods:{
        enterChat(){
          if(this.name){
            this.feedback=null
            this.$router.push({name:'Chat' ,params: {name:this.name}})

          }else{
            this.feedback="You must enter a name"
          }
        },
        showTerms(){
          this.terms ? this.terms=false : this.terms=true
        }
    }

}
</script>

<style>
.welcome{
  max-width: 400px;
  margin-top: 100px
}
.welcome button{
  margin-top: 20px
}
.welcome h2 p{
  font-size: 0.5em
}
p b{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Welcome.vue